import { useState } from 'react';
import { Box, Link, Text } from '@hopskipdrive/react-components';
import { Popover } from '@mui/material';
import { uniqueId } from 'lodash';
import pluralize from 'pluralize';

import { formatDate, formattedIsoDate } from '../../../utils/helpers/formatDate';

export const VariancesPopover = ({ variances }: { variances: Variance[] }) => {
  const [variancePopoverState, setVariancePopoverState] = useState(false);
  const [variancesAnchorEl, setVariancesAnchorEl] = useState({ x: 0, y: 0 });

  const handleVariancesPopover = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();

    setVariancesAnchorEl({ x: rect.x - 25, y: rect.y });
    setVariancePopoverState(!variancePopoverState);

    return;
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key == ' ') {
          handleVariancesPopover(event);
        }
      }}
      onClick={(event) => {
        handleVariancesPopover(event);
      }}
      style={{ cursor: 'pointer' }}
    >
      <span>{pluralize('variance', variances.length, true)}</span>
      <Popover
        open={variancePopoverState}
        anchorReference="anchorPosition"
        anchorPosition={{ top: variancesAnchorEl.y, left: variancesAnchorEl.x }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={() => {
          setVariancePopoverState(false);
        }}
      >
        <VariancesPopoverContent variances={variances} />
      </Popover>
    </div>
  );
};

const RenderVariance = (variance) => {
  const varianceDate = formatDate(new Date(formattedIsoDate(variance.date)), 'MM/dd/yyyy');

  return (
    <Box key={uniqueId()} border={1} p={4} borderRadius={3} bgcolor={'white'}>
      <Link disabled={!variance.slug} target="_blank" {...(variance.slug && { href: `/rides/${variance.slug}` })}>
        {varianceDate}
      </Link>
      <Text>{VarianceText(variance)}</Text>
    </Box>
  );
};

const VarianceText = (variance) => {
  if (variance.slug) {
    if (variance.type == 'time_route_change' || variance.type == 'route_change') {
      return (
        <span className="variance text" data-tooltip={variance.text}>
          Different Route
        </span>
      );
    }
    if (variance.text.startsWith('drop_off')) {
      return variance.text.replace('drop_off', 'Dropoff');
    } else if (variance.text.startsWith('pick_up')) {
      return variance.text.replace('pick_up', 'Pickup');
    }
  }

  return variance.text;
};
const VariancesPopoverContent = ({ variances }) => {
  const sortedVariances = variances.sort((a, b) => {
    const aDate = new Date(a.date);
    const bDate = new Date(b.date);

    return aDate.getTime() - bDate.getTime();
  });

  return (
    <Box bgcolor={'background'} flexDirection="column" border={1} maxHeight="50vh" overflow="auto">
      {sortedVariances.map((variance) => RenderVariance(variance))}
    </Box>
  );
};
